// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const PlanItemStatusSchema = z.enum(['PENDING','IN_PROGRESS','COMPLETED','CANCELLED'] as const);

export type PlanItemStatusType = `${z.infer<typeof PlanItemStatusSchema>}`

export default PlanItemStatusSchema;
